export default "__VITE_ASSET__AqvSlm4___$_?component__"